import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=04fbf815&scoped=true&"
import script from "./Detail2.vue?vue&type=script&lang=js&"
export * from "./Detail2.vue?vue&type=script&lang=js&"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=04fbf815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fbf815",
  null
  
)

export default component.exports